var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 192,
    viewBox: "0 0 192 192",
    width: 192,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "m170 42-148 82v14c0 6.627 5.373 12 12 12h78c6.627 0 12-5.373 12-12v-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170 150-148-82v-14c0-6.627 5.373-12 12-12h78c6.627 0 12 5.373 12 12v9.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapcut);
export default __webpack_public_path__ + "static/media/capcut.846fb0a73231c01cedadf31e87b67123.svg";
export { ForwardRef as ReactComponent };